"use client";

import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
export var ReadOnlyText = function ReadOnlyText(_ref) {
  var label = _ref.label,
    value = _ref.value;
  return /*#__PURE__*/React.createElement(Row, {
    gap: "1x"
  }, label ? /*#__PURE__*/React.createElement(Typography, null, label, ":") : null, /*#__PURE__*/React.createElement(Typography, null, value));
};